import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import Header from "../components/Header";
import Footer from "../components/Footer";
import MobileStickyBar from "../components/MobileStickyBar";
import Seo from "../components/Seo";
import { api, PROJECT_CATEGORIES, COMPANY, projectCover } from "../lib/site";
import { useLang } from "../i18n/LanguageContext";

export default function Projects() {
  const { t } = useLang();
  const [cat, setCat] = useState("Alle");
  const { data: projects = [] } = useQuery({ queryKey: ["projects", cat], queryFn: async () => (await api.get(`/projects${cat && cat !== "Alle" ? `?category=${encodeURIComponent(cat)}` : ""}`)).data });

  return (
    <div className="min-h-screen">
      <Seo title={`${t("nav.projects")} | ${COMPANY.name}`} description={t("section.projects.desc")} path="/prosjekter" />
      <Header />
      <section className="section">
        <div className="container-page">
          <span className="eyebrow">{t("nav.projects")}</span>
          <h1 className="mt-2 font-display text-4xl sm:text-5xl font-bold">{t("projects.pageTitle")}</h1>
          <div className="dot-divider mt-4" />
          <p className="mt-4 text-[#555E68] max-w-2xl">{t("section.projects.desc")}</p>

          <div className="mt-8 flex flex-wrap gap-2">
            {PROJECT_CATEGORIES.map((c) => (
              <button key={c} onClick={() => setCat(c)} className={`px-4 py-2 rounded-full text-sm font-semibold border transition-colors ${cat === c ? "bg-[#1B3626] border-[#1B3626] text-white" : "bg-white border-[#D5D0C7] text-[#1C1F22] hover:border-[#1B3626]"}`} data-testid={`filter-${c}`}>{c}</button>
            ))}
          </div>

          <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {projects.map((p) => (
              <Link to={`/prosjekter/${p.id}`} key={p.id} className="card-warm block" data-testid={`proj-${p.id}`}>
                <div className="aspect-[4/3] overflow-hidden">
                  <img src={projectCover(p)} alt={p.title} className="w-full h-full object-cover" loading="lazy" />
                </div>
                <div className="p-5">
                  <span className="text-xs font-bold uppercase tracking-widest text-[#1B3626]">{p.category}</span>
                  <h3 className="mt-1.5 font-display font-bold text-lg">{p.title}</h3>
                  <div className="text-sm text-[#555E68] mt-1">{p.location}</div>
                  <p className="mt-3 text-sm text-[#383E45] line-clamp-3">{p.description}</p>
                </div>
              </Link>
            ))}
            {projects.length === 0 && <div className="text-[#555E68]">{t("projects.empty")}</div>}
          </div>
        </div>
      </section>
      <Footer /><MobileStickyBar />
    </div>
  );
}
